module.exports = __webpack_public_path__ + "img/watermark.6214feb6.svg";